import AuthForm from '../components/forms/AuthForm';

function Register() {
  return <AuthForm route="register/" method="register" />;
}

export default Register;